import getDecorators from "inversify-inject-decorators";
import container from "../../../ioc/inversify.config";
import TYPES from "../../../ioc/types";
import { AuthenticatedAssetLoader } from "../../../services/authenticated-asset-loader";
import { DefaultEventService } from "../../../services/event-service";
import { KeyboardMappingService } from "../../../services/keyboardmapping-service";
import { ItemDefinitionDTO } from "../../../shared/dtos";
import { getAssetUrl, SceneId } from "../../../shared/enum";
import { ShopMenu } from "../../menu/shop-menu";

const { lazyInject } = getDecorators(container);

export class ItemShopBuyScene extends Phaser.Scene {
    private menu: ShopMenu;

    @lazyInject(TYPES.EventService)
    private eventService: DefaultEventService;

    @lazyInject(TYPES.KeyboardMappingService)
    private keyboardMappingService: KeyboardMappingService;

    @lazyInject(TYPES.AuthenticatedAssetLoader)
    private assetLoader: AuthenticatedAssetLoader;

    private availableItems: Array<ItemDefinitionDTO>;

    private callingScene: Phaser.Scene;

    constructor() {
        super({ key: SceneId.BUY_SCENE });
        console.log("constructing shop buy scene");
    }

    preload() {
        // Items spritesheet loaded in create() via authenticated proxy
    }

    public bindEvents() {
        console.log("binding shop scene events");
        //        if (this.input.keyboard.listenerCount('keydown') == 0 ) {
        this.input.keyboard.on("keydown", (event) => this.onKeyInput(event));
        //        }
    }

    public onKeyInput(event) {
        const controls = this.keyboardMappingService.getKeyboardMapping("mikado");
        console.log("key down event: ", event);
        if (event.code === "Key" + controls.cancelKey.toUpperCase()) {
            this.shoppingFinished();
        } else if (event.code === "Space") {
            this.menu.confirm();
        }
    }

    public shoppingFinished() {
        const controls = this.keyboardMappingService.getKeyboardMapping("mikado");
        //        this.input.keyboard.off('keydown-' + controls.cancelKey);
        this.scene.sleep();
        this.callingScene.scene.resume();
    }

    init(availableItems) {
        const layerScene = this.scene.get(SceneId.INFO_LAYER_SCENE);
        layerScene.scene.bringToTop();
        // listen for keyboard events
        // this.input.keyboard.on("keydown", this.onKeyInput, this);
        console.log("init shop buy scene");
        this.availableItems = availableItems.items;
        this.callingScene = availableItems.callingScene;
        console.log("shop buy scene called by : ", this.callingScene);
    }

    public create(sceneId: string) {
        console.log("basic shop buy scene creation");
        this.loadSpritesheets().then(() => {
            this.menu = new ShopMenu(0, 0, 0, 0, this.availableItems, this);
            this.menu.draw();
            this.bindEvents();
        }).catch((error) => {
            console.error("Failed to load shop spritesheet:", error);
        });
    }

    private async loadSpritesheets(): Promise<void> {
        const seen = new Set<string>();
        for (const item of this.availableItems ?? []) {
            const spriteData = item.sprite_data;
            if (!spriteData?.online_image || !spriteData.image_path) continue;
            const key = "items/" + spriteData.image_path;
            if (seen.has(key) || this.textures.exists(key)) continue;
            seen.add(key);
            const blobUrl = await this.assetLoader.fetchAsBlob(getAssetUrl(spriteData.online_image));
            await new Promise<void>((resolve) => {
                this.load.spritesheet(key, blobUrl, {
                    frameWidth: spriteData.width || 32,
                    frameHeight: spriteData.height || 32,
                } as Phaser.Types.Loader.FileTypes.ImageFrameConfig);
                this.load.once("complete", resolve);
                this.load.start();
            });
        }
    }

    // public onKeyInput(event: KeyboardEvent) {
    //     if (this.menu) {
    //         if (event.code === "ArrowUp") {
    //             this.menu.moveSelectionUp();
    //         } else if (event.code === "ArrowDown") {
    //             console.log('current sel: ', this.menu.menuItemIndex,
    //             ', items lenght: ', this.menu.menuItems.length);
    //             this.menu.moveSelectionDown();
    //         } else if (event.code === "ArrowRight") {
    //             this.menu.moveSelectionRight();
    //         } else if (event.code === "ArrowLeft") {
    //             this.menu.moveSelectionLeft();
    //         } else if (event.code === "Space") {
    //             this.menu.confirm();
    //         }
    //         this.menu.refreshDescription();
    //     }
    // }
}
